import React, { useState } from 'react';
import { useCookieConsent } from '../../context/CookieConsentContext';

const CookieBanner = () => {
  const { 
    showBanner, 
    acceptAll, 
    acceptNecessaryOnly, 
    updatePreferences, 
    preferences 
  } = useCookieConsent();
  
  const [showSettings, setShowSettings] = useState(false);
  const [tempPreferences, setTempPreferences] = useState(preferences);

  if (!showBanner) return null;

  const handleSettingsToggle = () => {
    setShowSettings(!showSettings);
    setTempPreferences(preferences);
  };

  const handlePreferenceChange = (type) => {
    if (type === 'necessary') return; // Necessary cookies can't be disabled
    
    setTempPreferences(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  const savePreferences = () => {
    updatePreferences(tempPreferences);
  };

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner">
        <div className="cookie-banner-content">
          <div className="cookie-banner-header">
            <div className="cookie-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#009B31"/>
              </svg>
            </div>
            <h3 className="cookie-banner-title">We Value Your Privacy</h3>
          </div>
          
          <div className="cookie-banner-text">
            <p>
              We use cookies to enhance your browsing experience, serve personalized content, 
              and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
            </p>
            <p>
              <a href="/privacy-policy" className="cookie-link" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              {' • '}
              <a href="/cookie-policy" className="cookie-link" target="_blank" rel="noopener noreferrer">
                Cookie Policy
              </a>
            </p>
          </div>

          {showSettings && (
            <div className="cookie-settings">
              <div className="cookie-category">
                <div className="cookie-category-header">
                  <label className="cookie-switch">
                    <input
                      type="checkbox"
                      checked={tempPreferences.necessary}
                      disabled
                      onChange={() => {}}
                    />
                    <span className="cookie-slider disabled"></span>
                  </label>
                  <div className="cookie-category-info">
                    <h4>Necessary Cookies</h4>
                    <p>Essential for the website to function properly. Cannot be disabled.</p>
                  </div>
                </div>
              </div>

              <div className="cookie-category">
                <div className="cookie-category-header">
                  <label className="cookie-switch">
                    <input
                      type="checkbox"
                      checked={tempPreferences.analytics}
                      onChange={() => handlePreferenceChange('analytics')}
                    />
                    <span className="cookie-slider"></span>
                  </label>
                  <div className="cookie-category-info">
                    <h4>Analytics Cookies</h4>
                    <p>Help us understand how visitors interact with our website by collecting anonymous information.</p>
                  </div>
                </div>
              </div>

              <div className="cookie-category">
                <div className="cookie-category-header">
                  <label className="cookie-switch">
                    <input
                      type="checkbox"
                      checked={tempPreferences.functional}
                      onChange={() => handlePreferenceChange('functional')}
                    />
                    <span className="cookie-slider"></span>
                  </label>
                  <div className="cookie-category-info">
                    <h4>Functional Cookies</h4>
                    <p>Enable enhanced functionality and personalization, such as remembering your preferences.</p>
                  </div>
                </div>
              </div>

              <div className="cookie-category">
                <div className="cookie-category-header">
                  <label className="cookie-switch">
                    <input
                      type="checkbox"
                      checked={tempPreferences.marketing}
                      onChange={() => handlePreferenceChange('marketing')}
                    />
                    <span className="cookie-slider"></span>
                  </label>
                  <div className="cookie-category-info">
                    <h4>Marketing Cookies</h4>
                    <p>Used to deliver relevant advertisements and track the effectiveness of our marketing campaigns.</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="cookie-banner-actions">
            {showSettings ? (
              <>
                <button 
                  className="cookie-btn cookie-btn-secondary"
                  onClick={handleSettingsToggle}
                >
                  Back
                </button>
                <button 
                  className="cookie-btn cookie-btn-primary"
                  onClick={savePreferences}
                >
                  Save Preferences
                </button>
              </>
            ) : (
              <>
                <button 
                  className="cookie-btn cookie-btn-secondary"
                  onClick={acceptNecessaryOnly}
                >
                  Necessary Only
                </button>
                <button 
                  className="cookie-btn cookie-btn-link"
                  onClick={handleSettingsToggle}
                >
                  Customize
                </button>
                <button 
                  className="cookie-btn cookie-btn-primary"
                  onClick={acceptAll}
                >
                  Accept All
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;